<!-- TODO: check if alt text FR translations are correct -->
<!-- Note: consider BEM notation for class names maybe! -->
<!-- Note: micro-compile documentation with Radish best practices and links to resources -->

<div #servicePauseModal>
    <div class="service-pause-modal-content">
        <!-- <button -->
        <!--     type="button" -->
        <!--     class="service-pause-modal-dismiss-btn" -->
        <!--     (click)="activeModal.dismiss()" -->
        <!-- > -->
        <!--     <img -->
        <!--         class="dismiss-btn-icon" -->
        <!--         src="../../../assets/images/close-icon.png" -->
        <!--         [alt]="'common.dismiss' | transloco" -->
        <!--     /> -->
        <!-- </button> -->

        <div class="service-pause-modal-header">
            <h2 class="service-pause-modal-title">
                {{ 'modals.servicePause.header' | transloco }}
            </h2>
            <!---->
            <!-- <!-- Date and Time -->
            <!-- @if (data.interval.active) { -->
            <!--     <h3 class="service-pause-modal-subtitle"> -->
            <!--         {{ -->
            <!--             'modals.servicePause.header.subtitle.time' -->
            <!--                 | transloco: { time: servicePauseEndTime } -->
            <!--         }} -->
            <!--     </h3> -->
            <!---->
            <!--     <!-- Time only -->
            <!--     <h3 class="service-pause-modal-subtitle"> -->
            <!--         {{ -->
            <!--             'modals.servicePause.header.subtitle.time' -->
            <!--                 | transloco: { time: servicePauseEndTime } -->
            <!--         }} -->
            <!--     </h3> -->
            <!-- } -->
        </div>

        <div class="service-pause-modal-body">
            @if (data.image) {
                <div class="service-pause-modal-image-container">
                    <img [src]="data.image" class="service-pause-modal-image" alt="" />
                </div>
            }
            <p class="service-pause-modal-body-text">
                {{ 'modals.servicePause.body.first' | transloco }}
            </p>
            <p class="service-pause-modal-body-text">
                {{ 'modals.servicePause.body.second' | transloco }}
            </p>
        </div>

        <!-- Mailchimp embeded form -->
        <form
            action="https://radish.us8.list-manage.com/subscribe/post?u=65ce400c2425d4b950da13793&id=f660418979&f_id=0093c2e2f0%22"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
        >
            <div id="mc_embed_signup_scroll">
                <div class="mc-field-group">
                    <label for="mce-EMAIL">{{ 'modals.servicePause.form.email' | transloco }}</label
                    ><input
                        type="email"
                        name="EMAIL"
                        class="required email"
                        id="mce-EMAIL"
                        required=""
                        value=""
                    />
                </div>
                <div class="mc-field-group">
                    <label for="mce-MMERGE1">{{
                        'modals.servicePause.form.firstName' | transloco
                    }}</label
                    ><input type="text" name="MMERGE1" class="text" id="mce-MMERGE1" value="" />
                </div>
                <div id="mce-responses" class="clear foot">
                    <div class="response" id="mce-error-response" style="display: none"></div>
                    <div class="response" id="mce-success-response" style="display: none"></div>
                </div>
                <div aria-hidden="true" style="position: absolute; left: -5000px">
                    /* real people should not fill this in and expect good things - do not remove
                    this or risk form bot signups */
                    <input
                        type="text"
                        name="b_65ce400c2425d4b950da13793_f660418979"
                        tabindex="-1"
                        value=""
                    />
                </div>
                <div class="optionalParent">
                    <div class="clear foot">
                        <input
                            type="submit"
                            name="subscribe"
                            id="mc-embedded-subscribe"
                            class="button"
                            [value]="'modals.servicePause.form.submit' | transloco"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- alternative close icon -->
<!-- <img class="dismiss-btn-icon" src="../../../assets/images/icons/dismiss.svg" [alt]="'common.dismiss' | transloco" /> -->
